import Vue from 'vue'
import Vuex from 'vuex'
import configuration from './modules/configuration'
import filter from './modules/filter'
import cache from './modules/cache'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  modules: {
    configuration,
    filter,
    cache
  },
  getters: {
    configuration: state => state.configuration
  }
})
